import React from 'react';
import './manager-trade-portal.styles.scss';
import TradePortal from '@/components/SHARED/trade-portal/trade-portal.component';
import BackButton from '@/components/SHARED/back-button/back-button.component';
import { useNavigate } from 'react-router-dom';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';

const ManagerTradePortal = ({
	gameData,
	playerList,
	gameElements
}) => {

	const navigate = useNavigate();

	return (
		<div className='manager-trade-portal'>
			<div className='g-card manager-trade-portal-card'>
				<BackButton cancel={() => navigate(-1)} />
				<div className="g-space-1"></div>
				<div className='card-title'>
					<ImageContainer src='/images/icons/tradeportal.png' className='head-icon' />
					Trade Portal</div>
				<hr />
				<TradePortal
					isManager={true}
					gameData={gameData}
					gameElements={gameElements}
					playerList={playerList} />
			</div>
		</div>
	)
}

export default ManagerTradePortal